module.exports = __webpack_public_path__ + "img/tratativa.3cc9d520.svg";